import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import type { ConversationType } from '@/models/conversations/conversation-session';
import { type RespondedWith, responseScheme } from '@/models/response';
import { useMessageStore } from '@/stores/message';
import { fetcher } from '@/utils/fetcher';

export const generateDeletedMessagesQueryOptions = (type: ConversationType, id: Nullable<number>) =>
  queryOptions({
    queryKey: [type === 'session' ? '/GetDeleteChat' : '/GetDeleteGroupChat', id],
    queryFn: id
      ? async ({ signal }) => {
          const response = await fetcher<RespondedWith<number[]>>(
            type === 'session' ? '/GetDeleteChat' : '/GetDeleteGroupChat',
            {
              [type === 'session' ? 'ChatSessionID' : 'GroupID']: id,
            },
            {
              signal,
              validResponseCodes: [0],
              schema: responseScheme.extend({ Data: z.array(z.number()).nullish() }),
            },
          );

          const result = response?.Data ?? [];

          if (result.length > 0) useMessageStore.getState().deleteMany(result, type, id);

          return result;
        }
      : skipToken,
    staleTime: 0,
  });

export default function useDeletedMessages(type: ConversationType, id: Nullable<number>) {
  return useQuery(generateDeletedMessagesQueryOptions(type, id));
}
